module.exports = __webpack_public_path__ + "img/img19.d64799ec.png";